export default {
  columns: {
    version: 'Versio',
    signed_at: 'Allekirjoitettu',
    internal_note: 'Sisäinen huomautus',
    signature_provider: 'Allekirjoituspalvelun tarjoaja',
    file: 'Asiakirja',
    actions: 'Toiminnot',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Allekirjoitushistoriaa ei vielä ole',
    providers: {
      selfhosted: 'Itse ylläpidetty',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Esikatselu',
    download: 'Lataa',
  },
};
